var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"afm-star-container"},[_c('div',{staticClass:"star-img-container"},[_vm._l((_vm.getStarIndex(_vm.rating)),function(item,index){return _c('img',{key:index,staticClass:"star-img",attrs:{"data-index":index,"src":item,"alt":""}})}),_vm._v(" "),_c('p',{staticClass:"star-text"},[_vm._v(_vm._s(_vm.rating))])],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a6789384","hasScoped":false,"transformToRequire":{"vue-h-zoom":["image","image-full"]},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/afm-star/afm-star.vue
// module id = null
// module chunks = 